import { Box, List, styled, useMediaQuery, useTheme } from "@mui/material";
import React, { useEffect, useState, useCallback } from "react";
import AppHeader from "./parts/AppHeader";
import SeeApp from "./parts/SeeApp";
import AuthService from "../../AuthService";
import Hidden from "../Hidden";
import AppDrawer from "./parts/AppDrawer";
import DialogTutorial from "../DialogTutorial";

const ScrollableList = styled(List)(({ theme }) => ({
  padding: 0,
  margin: 0,
  width: "100%",
  height: "100%",
  overflowY: "auto",
  maxHeight: "100vh",
  overflowX: "hidden",
}));

const MainLayout = React.memo(({ children }) => {
  const [open, setOpen] = useState(false);
  const [openTutorial, setOpenTutorial] = useState(false);
  const [empresa, setEmpresa] = useState(null);
  const [identificadorDelivery, setIdentificadorDelivery] = useState(null);
  const [openTesteApp, setOpenTesteApp] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const auth = new AuthService();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.down("md"));
  const isTemporaria =
    empresa?.tipoConta === "TEMPORARIA" ||
    empresa?.tipoConta === "TEMPORARIA_EXTENDED";

  const padding = isMobile ? 2 : isTablet ? 3 : 5;
  const marginTop = (isTemporaria ? 2 : 0) + (isMobile ? 3 : isTablet ? 2 : 1);

  const getIdentificadorDelivery = useCallback(() => {
    const service = new AuthService();
    service.get("/identificador/getFirstDelivery").then((resp) => {
      if (resp.id) {
        setIdentificadorDelivery(resp.uuid);
        const tipoConta = resp.empresa?.tipoConta;
        if (["TEMPORARIA", "TEMPORARIA_EXTENDED"].includes(tipoConta)) {
          setOpenTesteApp(localStorage.getItem("_TESTE_APP_") !== "false");
        }
      }
    });
  }, []);

  const getEmpresa = useCallback(() => {
    auth.get(`/empresa/${auth.getProfile().empresa.id}`).then((resp) => {
      setEmpresa(resp);
      const profile = auth.getProfile();
      profile.empresa = resp;
      auth.setProfile(profile);
    });
  }, [auth]);

  useEffect(() => {
    const fetchData = () => {
      getEmpresa();
      setOpenTutorial(localStorage.getItem("_OPEN_TUTORIAL_") !== "false");
      getIdentificadorDelivery();
    };

    fetchData();
    const interval = setInterval(fetchData, 30000);

    return () => clearInterval(interval);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const toogleDrawerOpen = () => setOpen(!open);

  const toogleTesteApp = () => {
    setOpenTesteApp(!openTesteApp);
    localStorage.setItem("_TESTE_APP_", !openTesteApp);
  };

  const toogleOpenTutorial = () => {
    setOpenTutorial(!openTutorial);
    localStorage.setItem("_OPEN_TUTORIAL_", !openTutorial);
  };

  if (!auth.loggedIn()) return null;

  return (
    <Box>
      <Box sx={{ display: "flex", width: "100%" }}>
        <AppHeader
          open={open}
          empresa={empresa}
          isTemporaria={isTemporaria}
          onOpen={toogleDrawerOpen}
          identificadorDelivery={identificadorDelivery}
          openTutorial={openTutorial}
          openTesteApp={openTesteApp}
          setOpenTesteApp={setOpenTesteApp}
          setOpenTutorial={setOpenTutorial}
        />
        <Hidden lgDown={open ? false : true}>
          <AppDrawer
            setOpen={setOpen}
            isTemporaria={isTemporaria}
            open={open}
          />
        </Hidden>
        <ScrollableList
          sx={{
            "&::-webkit-scrollbar": {
              width: "0.4rem",
            },
            "&::-webkit-scrollbar-thumb": {
              borderRadius: "10px",
              background: (theme) => theme.palette.primary.main,
              boxShadow: "inset 0 0 6px rgba(0,0,0,0.5)",
            },
          }}
        >
          <Box width="100%">
            <Box
              component="main"
              sx={{
                padding: `${padding}rem`,
                marginTop: `${marginTop}rem`,
              }}
            >
              {children}
            </Box>
          </Box>
        </ScrollableList>
        <SeeApp
          openTesteApp={openTesteApp}
          toogleTesteApp={toogleTesteApp}
          identificadorDelivery={identificadorDelivery}
        />
        {isTemporaria && (
          <DialogTutorial open={openTutorial} close={toogleOpenTutorial} />
        )}
      </Box>
    </Box>
  );
});

export default MainLayout;
